/*
 * @Descripttion: 场景价格管理 API
 * @Date: 2026-07-02 10:00:00
 */
import http from '@/utils/http/axios';
import type {
  IndustryPriceTreeResponse,
  SaveOpenedScenesParams,
  ScenePriceConfigDetail
} from './types';
import {
  mapIndustryPriceTreeToScenes,
  normalizeIndustryPriceTreeData
} from '../utils/industry-price-tree';
import { buildSaveOpenedScenesParams } from '../utils/save-opened-scenes';

export { buildSaveOpenedScenesParams };

const yApiObj = {
  // yapi: 1271
};

const requestConfig = {
  isParseToJson: true,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  },
  ...yApiObj
};

enum Api {
  industryPriceList = '/back-end/spc/api/v1/industryPriceList',
  industryPriceTree = '/back-end/spc/api/v1/industryPriceTree',
  saveOpenedScenes = '/back-end/spc/api/v1/saveOpenedScenes'
}

/**
 * 场景价格列表
 */
export const listPage = async (params: Record<string, any>) =>
  http.request(
    {
      url: Api.industryPriceList,
      method: 'POST',
      params
    },
    requestConfig
  );

/**
 * 获取工业价格配置树
 */
export const getIndustryPriceTree = async (industryId?: number) => {
  const res = await http.request<IndustryPriceTreeResponse>(
    {
      url: Api.industryPriceTree,
      method: 'POST',
      params: { industryId }
    },
    requestConfig
  );
  const treeData = normalizeIndustryPriceTreeData(res);
  return mapIndustryPriceTreeToScenes(treeData);
};

/**
 * 获取工业场景价格配置
 */
export const getConfigDetail = async (params: {
  industryId?: string | number;
  industryName?: string;
}) => {
  const industryId =
    params.industryId != null ? Number(params.industryId) : undefined;
  const scenes = await getIndustryPriceTree(industryId);

  return {
    data: {
      industryId: params.industryId,
      industryName: params.industryName || '',
      scenes
    } satisfies ScenePriceConfigDetail
  };
};

/**
 * 保存开通场景及工业价格
 */
export const saveOpenedScenes = (params: SaveOpenedScenesParams) =>
  http.request(
    {
      url: Api.saveOpenedScenes,
      method: 'POST',
      params
    },
    requestConfig
  );

/**
 * 根据页面场景数据保存开通场景
 */
export const saveScenes = (
  industryId: string | number,
  scenes: ScenePriceConfigDetail['scenes']
) => saveOpenedScenes(buildSaveOpenedScenesParams(industryId, scenes));
